import React, { useState, useEffect } from "react";
import { Button, Card, CardContent, CardHeader, Checkbox, Grid, IconButton } from "@mui/material";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { CheckBox, PrintIcon, UploadFile } from "@egovernments/digit-ui-react-components";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import ChatBoardHistory from "../ChatBoardHistory";
import FormattedDate from "../../TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import DescriptionIcon from "@mui/icons-material/Description";
import FileUploaderNew from "../../../pages/citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";


// import ChatBoardHistory from "./ChatBoardHistory";

const ChatboardCorrespondenceApplicant = ({ formData }) => {
  const { t } = useTranslation();
  const Modal = useModal();
  const [content, setContent] = useState("");
  const [chatBoardDataRemarks, setChatBoardDataRemarks] = useState({});
  const [chatBoardHistoryData, setChatBoardHistoryData] = useState({});
  const [loader, setLoader] = useState(false);
  const userData = Digit.UserService.getUser() || {};
  const userInfo = userData?.info || {};
  const authToken = userData?.access_token || null;
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const filterDataRole = userRolesArray?.[0]?.code;
  const designation = userRolesArray?.[0]?.name;
  const [developerRemarks, setDeveloperRemarks] = React.useState("");
  const [messageTo, setMessageTo] = React.useState(undefined);
  const [applicantChecked, setApplicantChecked] = useState(false);
  const [ownerChecked, setOwnerChecked] = useState(false);
  const [developerChecked, setDeveloperChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [uploadedFileAttachment, setUploadedFileAttachment] = useState(null);
  const [chatBoardDocs, setChatBoardDocs] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [createdTime, setCreatedTime] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [error, setError] = useState(null);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }


  const openPopup = (item) => {
    debugger;
    let rows = [];
    rows = item?.documentId || [];

    setShowPopup(true);
    setSelectedDetails(rows);
    // setUserDetails(item.userDetails || {});
    setCreatedTime(item?.createdOn || null);
    setPopupData(item);

  };

  console.log("slectedDetails", selectedDetails);
  const printPopup = () => {
    debugger;
    const popupContent = document.getElementById("popup-print-content");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Details</title>
          <style>
            body { font-size: 11px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #e2e8f0; font-size: 13px; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedDetails([]);
    // setUserDetails(null);
    setPopupData(null);
  };


  const handleUpdate = (event) => {
    const editorContent = event.target.innerHTML;
    setContent(editorContent);
  };
  const handlemodalAttachment = (e) => {
    setUploadedFileAttachment("AttachmentOPen");
  };

  const closeEditor = () => {
    setContent("");
    setDeveloperRemarks("");
  };
  const onMessageToChange = (e) => {
    //  debugger;
    if (e.target.value !== messageTo) {
      if (e.target.checked) {
        setMessageTo(e.target.value);
        if (e.target.value === "Applicant") {
          setApplicantChecked(true);
          setOwnerChecked(false);
          setDeveloperChecked(false);
        } else if (e.target.value === "Owner/Developer") {
          setApplicantChecked(false);
          setOwnerChecked(true);
          setDeveloperChecked(false);
        } else if (e.target.value === "Department") {
          setApplicantChecked(false);
          setOwnerChecked(false);
          setDeveloperChecked(true);
        }
      }
    }
  };

  const handlemodalsubmit = async () => {
    setLoader(true);
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken,
      },
      egScrutiny: {
        applicationId: formData?.applicationNo,
        comment: developerRemarks,
        fieldValue: messageTo ? true : false,
        fieldIdL: messageTo ? messageTo : "",
        isApproved: "CHAT_BOARD",
        isLOIPart: true, //Message To
        userid: userInfo?.id || null,
        serviceId: 123,
        documentId: chatBoardDocs, //document attachment
        bussinessServiceName: formData?.businessService,
        designation: designation,
        name: userInfo?.type || null,
        employeeName: userInfo?.name || null,
        role: filterDataRole,
        applicationStatus: formData?.status,
      },
    };

    try {
      const Resp = await axios.post("/land-services/egscrutiny/_create?status=submit", postData, {}).then((response) => {
        return response.data;
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
    }
    let redirectPath = "";

    if (formData?.applicationType === "FORM_MAP") {
      redirectPath = `/digit-ui/employee/obps/application/MAP_SUB/${formData?.applicationNo}`;
    } else if (formData?.applicationType === "FORM_PURCHASABLE_FAR") {
      redirectPath = `/digit-ui/employee/obps/application/PURCHASABLE_FAR/${formData?.applicationNo}`;
    } else {
      redirectPath = `/digit-ui/employee/obps/application/formLandUse/${formData?.applicationNo}`;
    }

    Modal(
      "Application Chat Board",
      `Application <strong>(${formData?.applicationNo}) Chat Board</strong> Successfully!`,
      "success"
      //  redirectPath
    );
    await handleGetRemarkssValues(formData?.applicationNo), handleGetHistoryRemarkssValues(formData?.applicationNo);
  };
  const handleGetRemarkssValues = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.land.chatBoard_data_search}=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      setChatBoardDataRemarks(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetHistoryRemarkssValues = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.land.chatBoard_data_search3}=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      // setNotingRemarksData(Resp);
      setChatBoardHistoryData(Resp);
    } catch (error) {
      console.log(error);
    }
  };

  const [post, setPost] = useState({
    // title: '',
    content: "",
    hearingDate: "",
    // categoryId: ''
  });
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);

  //  useEffect(() => {
  //      debugger;
  //      if (formData?.applicationNo) {
  //        handleGetRemarkssValues(formData?.applicationNo);
  //        handleGetHistoryRemarkssValues(formData?.applicationNo);
  //      }
  //    }, [formData?.applicationNo]);

  useEffect(() => {
    updateCheckBoxSize();
  }, []);
  const updateCheckBoxSize = () => {
    var eles = document.querySelectorAll(".custom-checkbox");
    var index = 0,
      length = eles.length;
    for (; index < length; index++) {
      eles[index].style.width = "20px";
      eles[index].style.height = "20px";
      eles[index].style.marginTop = "5px";
    }
  };
  useEffect(() => {
    const fetchRemarks = async () => {
      if (!formData?.applicationNo) return;

      try {
        await handleGetRemarkssValues(formData?.applicationNo);
        await handleGetHistoryRemarkssValues(formData?.applicationNo);
      } catch (error) {
        console.error("Error fetching remarks:", error);
      }
    };

    fetchRemarks();
  }, [formData?.applicationNo]);
  // let egScrutinyData = chatBoardHistoryData?.egScrutiny?.filter(e => (e.fieldIdL === "Department" || e.fieldIdL === "Applicant") && e.name === "CITIZEN");
  let egScrutinyData = chatBoardHistoryData?.egScrutiny?.filter((e) => !(e.fieldIdL === "Department" && e.name !== "CITIZEN"));

  console.log("egScrutinyDataApplicant", egScrutinyData);
  return (
    <div>
      <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <h2
          style={{
            background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
            fontFamily: "Roboto",
            height: "44px",
            padding: "10px",
            color: "#fff",
          }}
        >
          Application Details
        </h2>

        {/* <CardHeader title="Application Details" titleTypographyProps={{fontSize:'16px',fontWeight:'600',color:'#1F4A7C'}} style={{backgroundColor:'#1F4A7C',padding:'10px'}} ></CardHeader> */}
        <Grid container spacing={1} className="common-app-form">
          <Grid style={{ fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>File Number:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.applicationNo}
          </Grid>
          <Grid style={{ fontSize: "13px" }} item xs={6} md={3}>
            <strong>Submitted On:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {ConvertEpochToDate(formData?.auditDetails?.createdTime)}
          </Grid>
          <Grid style={{ fontSize: "13px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>Name of Owner/Applicant:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.landInfo?.owners?.[0]?.name}
          </Grid>
          <Grid style={{ fontSize: "13px" }} item xs={6} md={3}>
            <strong>Name of Architect:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px" }} item xs={6} md={3}>
            {formData?.professionalInformation?.name}
          </Grid>
          {/* <Grid style={{backgroundColor:'#E6EFF8', fontSize:"13px",paddingLeft:'20px',paddingBottom:'3px'}} item xs={6} md={3}>
              <strong>Case Type:</strong>
       </Grid>
       <Grid style={{backgroundColor:'#FFFFFF', fontSize:"13px",paddingBottom:'3px'}} item xs={6} md={3}>
              {formData?.natureOfConstruction}
       </Grid> */}
          <Grid style={{ fontSize: "13px", paddingBottom: "3px", paddingLeft: "20px" }} item xs={6} md={3}>
            <strong>Project Type:</strong>
          </Grid>
          <Grid style={{ backgroundColor: "#FFFFFF", fontSize: "13px", paddingBottom: "3px" }} item xs={6} md={3}>
            {formData?.applicationType}
          </Grid>
        </Grid>
      </Card>

      <Card style={{ marginTop: "1rem" }}>
        <Grid container spacing={1}>
          <Grid style={{ paddingLeft: "20px", paddingTop: "20px" }} item xs={6} md={3}>
            <strong>Message To</strong>
          </Grid>
          <Grid item xs={18} md={9}>
            <CheckBox
              className="form-field"
              label={`Department`}
              onChange={onMessageToChange}
              checked={developerChecked}
              style={{ marginLeft: "25px", paddingTop: "3px", fontSize: "14px", paddingLeft: "10px" }}
            />
          </Grid>
          {/* </Grid> */}
        </Grid>
      </Card>

      <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
        <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
        {uploadedFileAttachment === "AttachmentOPen" && (
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
            <Box gridColumn="span 3"> Document /Certificate</Box>
            <Box gridColumn="span 9">
              {/* <UploadFile
                id={"workflow-doc"}
                onUpload={selectFile}
                onDelete={() => {
                  setUploadedFile(null);
                }}
                message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                accept="image/*, .pdf, .png, .jpeg, .jpg"
                iserror={error}
              /> */}
              <FileUploaderNew
                // isMandatory
                // label="Upload Document"
                // control={control}
                // name="siteInspectionDocument"
                validationMsg="(jpg, jpeg, pdf, png file only and Max file Size 30 MB)"
                // required
                tab={2}
                maxFiles={5}
                uploadedDocs={chatBoardDocs}
                setUploadedDocs={setChatBoardDocs}
              />
            </Box>
          </Box>
        )}

        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: 20, color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalsubmit}
        >
          Send
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "10px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={closeEditor}
        >
          Cancel
        </Button>
        <Button
          className="submit-bar submit-bar-take-action"
          style={{ marginLeft: "70px", color: "#fff", textAlign: "center", marginBottom: "5px" }}
          onClick={handlemodalAttachment}
        >
          Attachment
        </Button>
      </Card>
      {formData && egScrutinyData && (
        <Card style={{ marginTop: "1rem", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
          <h2
            style={{
              background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
              fontFamily: "Roboto",
              padding: "10px",
              color: "#fff",
            }}
          >
            History Of Web Message
          </h2>
          {/* <CardHeader title="History Of Web Message" titleTypographyProps={{fontSize:'16px',fontWeight:'600',color:'#FFFFFF'}} style={{backgroundColor:'#1F4A7C',padding:'10px'}}></CardHeader> */}
          <section className="remarks-table">
            <table>
              <thead>
                <tr>
                  <th style={{ fontSize: "12px" }}>Sr. No</th>
                  <th style={{ fontSize: "12px" }}>AssignTo</th>
                  <th style={{ fontSize: "12px" }}>Message To</th>
                  <th style={{ fontSize: "12px" }}>Message</th>
                  <th style={{ fontSize: "12px" }}>File Number</th>
                  <th style={{ fontSize: "12px" }}>Created By</th>
                  {/* <th style={{fontSize:'12px'}}>Recipients</th> */}
                  <th style={{ fontSize: "12px" }}>Date</th>
                  <th style={{ fontSize: "12px" }}>Attachments</th>
                </tr>
              </thead>
              <tbody>
                {egScrutinyData?.map((item, index) => (
                  <tr key={index}>
                    <td style={{ fontSize: "12px" }}>{index + 1}</td>
                    <td style={{ fontSize: "12px" }}> {item?.assignTo ? `${item.assignTo.name}, ${item.assignTo.code}` : `${item?.fieldIdL}`}</td>
                    <td style={{ fontSize: "12px" }}>{item?.fieldIdL}</td>
                    <td style={{ fontSize: "12px" }}>{<SafeHtml html={item?.comment} />}</td>
                    <td style={{ fontSize: "12px" }}>{item?.applicationId}</td>
                    <td style={{ fontSize: "12px" }}>
                      {item?.employeeName},({item?.designation})
                    </td>
                    {/* <td style={{fontSize:'12px'}}></td> */}
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      <FormattedDate timestamp={item?.createdOn} />
                    </td>
                    <td style={{ fontSize: '12px' }}>
                      <IconButton onClick={() => openPopup(item)} size="small">
                        <VisibilityIcon fontSize="small" />
                      </IconButton>

                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </Card>
      )}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "60%",
            transform: "translateX(-50%)",
            backgroundColor: "#f3f4f6",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "75%",
            // maxWidth: "800px",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "11px",
          }}
        >


          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ fontSize: "14px" }}>
              Document Details
            </h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="popup-print-content">

            <div style={{ marginBottom: "10px" }}>
              <strong>User:</strong> {popupData?.employeeName || "-"} |{" "}
              <strong>Designation:</strong> {popupData?.designation || "-"} |{" "}
              <strong>Role:</strong> {popupData?.role || "-"} |{" "}
              {/* <strong>Created At:</strong> {formatDate(createdTime)}  */}
              <strong>Created At:</strong> <FormattedDate timestamp={createdTime} />
            </div>
            <table
              border="1"
              cellPadding="6"
              width="100%"
              style={{ borderCollapse: "collapse", fontSize: "11px" }}
            >
              <thead style={{ backgroundColor: "#e2e8f0" }}>

                <tr>

                  <th>Document Type</th>
                  <th>File Name</th>

                </tr>

              </thead>
              <tbody>
                {selectedDetails?.map((row, i) => (
                  <tr key={i}>
                    <React.Fragment>
                      <td>{row?.documentType}</td>
                      <td>
                        {row?.documentUrl && (
                          <IconButton
                            href={row.documentUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                            style={{ marginLeft: 8 }}
                            title="Open Document"
                          >
                            <DescriptionIcon fontSize="small" />
                          </IconButton>
                        )}
                      </td>
                    </React.Fragment>
                  </tr>
                ))}

              </tbody>

            </table>
          </div>
        </div>
      )}
      {/* {formData && chatBoardHistoryData &&(
 <ChatBoardHistory formData={formData} chatBoardDataRemarks={chatBoardHistoryData}/>
)} */}
    </div>
  );
};

export default ChatboardCorrespondenceApplicant;
